const SiteUrl = process.env.REACT_APP_SITEURL;

const ShowImagePath = (folder, image) => {
  let imagePath = "";
  if (image) {
    imagePath = `${SiteUrl}${folder}${image}`;
  } else {
    imagePath = "";
  }
  return imagePath;
};

const formatDate = (inputDate) => {
  const [day, month, year] = inputDate.split("-");
  return `${day} ${new Date(year, month - 1, day).toLocaleString("en-US", {
    month: "short",
  })} ${year}`;
};

function formatYearDate(date_new) {
  if (!date_new || typeof date_new !== "string") {
    console.warn("Invalid date format:", date_new);
    return "";
  }
  const [day, month, year] = date_new.split("-");
  return `${year}-${month}-${day}`;
}

const formatPrice = (price) => {
  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    minimumFractionDigits: 2,
  }).format(price);
};

export default ShowImagePath;
export { formatDate, formatPrice, formatYearDate };
